import { LineChart } from "@mui/x-charts"
import { METER_TYPE } from "config/const"
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { findKeyByValue, findMeterQtyi18Key } from "config/functions";
import CustomButton from "components/CustomButton";
import CustomCard from "components/CustomCard";

const ChartWeeklyAverage = ({ selectedMeter, selectedMeterType, selectMeterType }) => {
  const theme = useTheme();
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <CustomCard width={isMobile ? '100%' : '40%'} border='1px solid #000'>
      <Typography fontWeight='bold' textAlign='center'>
        {bt('AVERAGE_WEEKLY')}
      </Typography>

      <LineChart
        series={
          selectedMeterType?.list
            ?.map(m => {
              return ({
                data: Array.from(m?.consumptionLasWeekly, v => v ?? 0),
                label: m?.name,
                valueFormatter: (n) =>
                  (n === null ? '' : `${parseFloat(n).toFixed(2)} ${bt(findMeterQtyi18Key(selectedMeter?.type))}`),
                // color: getRandomColor(),
                curve: "natural",
                showMark: true,
                markSize: isMobile ? 6 : 4,
                strokeWidth: isMobile ? 3 : 2,
              })
            })
        }
        xAxis={[{
          scaleType: "point",
          data: Array.from({ length: 5 }, (_, index) => index + 1)
        }]}
        style={{ width: '100%' }}
        height={300}
        slotProps={{ legend: { hidden: true } }}
      />

      <Stack direction='row' spacing={2} padding={1}>
        {Object.keys(METER_TYPE)?.map((key, idx) => {
          const value = METER_TYPE[key]
          return (
            <CustomButton
              key={idx}
              variant={value === selectedMeterType?.type ? "contained" : "outlined"}
              title={`${bt(findKeyByValue(METER_TYPE, value))}`}
              onClick={() => selectMeterType(value)}
            />
          )
        })}
      </Stack>
    </CustomCard>
  )
}
export default ChartWeeklyAverage